/**
 * Location effect handlers that must run on the interacting player's OWN
 * browser (they touch private/local state): loot drops, UI, audio. Everything
 * else in a location's effects is a host-side "world" effect, applied by the
 * host for the acting player and replicated through the usual channels. The two
 * consumption handlers (`markPoiUsed` / `triggerPoiBreakAnimation`) are driven
 * by `LocationService`, not run generically. See docs/multiplayer.md.
 */
export const OWNER_LOCAL_LOCATION_HANDLERS: ReadonlySet<string> = new Set([
  'spawnItemsFromPool',
  'spawnWeightedPool',
  'spawnRandomGrimoire',
  'spawnBoost',
  'openInterface',
  'playSound',
]);

export function isOwnerLocalLocationHandler(handler: string): boolean {
  return OWNER_LOCAL_LOCATION_HANDLERS.has(handler);
}

export function isConsumptionLocationHandler(handler: string): boolean {
  return handler === 'markPoiUsed' || handler === 'triggerPoiBreakAnimation';
}
